import type React from 'react'

import { AuthLayoutWrapperSC } from 'blocks/AuthLayout/AuthLayout.styled'

export const AuthLayoutWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return <AuthLayoutWrapperSC>{children}</AuthLayoutWrapperSC>
}
